
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-3edb5e96\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"data\":\"@import '~@/assets/scss/_settings.scss';\\n\",\"sourceMap\":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Image.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Image.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3edb5e96\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Image.vue"),
  /* scopeId */
  "data-v-3edb5e96",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/content/Image.vue
// module id = 64
// module chunks = 0